import { parseISO } from 'date-fns';
import { formatDate } from '../formatDate';

type IFormatDateString = (args: {
  dateString: string;
  formatType: Parameters<typeof formatDate>[0]['formatType'];
}) => string;

/**
 * 'YYYY-MM-DD' 形式の日付文字列を指定した表示形式に変換する
 *
 * new Date('YYYY-MM-DD') は UTC 0 時として解釈され、負のオフセットのタイムゾーンでは前日にずれるため、
 * parseISO でローカル日付として解釈する。解釈できない文字列の場合は date-fns の format が RangeError を投げる
 */
export const formatDateString: IFormatDateString = ({ dateString, formatType }) =>
  formatDate({ date: parseISO(dateString), formatType });
